/**
 * Domains added here should be ignored by each consent manager SDK.
 */
export const COOKIE_CONSENT_ALLOWED_DOMAINS = Object.freeze([
  'config-dev.enniscdn.net',
  'config-live.enniscdn.net',
]);
